import { Cookies } from 'react-cookie'
import { get_cart } from './cart';
import { get_wish } from './wish';
const cookie = new Cookies()

export const loginfill = async () => {

    const cartobjects = await get_cart()
    const wishobjects = await get_wish()
    const cartproducts = cartobjects?.map(a => ({ id: a.product_id, size: a.size }))
    const wishproducts = wishobjects?.map(a => a.product_id)

    cookie.set("mycart", cartproducts, { path: "/" });
    cookie.set("mywish", wishproducts, { path: "/" });
}

export const getpersonal = () => {
    const cart = cookie.get("mycart")
    const wish = cookie.get("mywish")

    return ({ cart: cart, wish: wish })
}
export const update = async () => {
    await loginfill()
    return getpersonal()
}